import { render, staticRenderFns } from "./user-notifications.vue?vue&type=template&id=7bc2dc18"
import script from "./user-notifications.vue?vue&type=script&lang=js"
export * from "./user-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc2dc18')) {
      api.createRecord('7bc2dc18', component.options)
    } else {
      api.reload('7bc2dc18', component.options)
    }
    module.hot.accept("./user-notifications.vue?vue&type=template&id=7bc2dc18", function () {
      api.rerender('7bc2dc18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user-notifications/user-notifications.vue"
export default component.exports